import { IList } from 'annotation-tools/utils';
import React, { FC, memo, useMemo } from 'react';
import { modelDetailEnabledButtons } from '../../../constants/model-detail-enabled-buttons';
import { viewTexts } from '../../../constants/view-texts';
import { ICompanyType } from '../../../types/record/company';
import { IImageInfoType } from '../../../types/record/image-info';
import { ILabelFromApiType } from '../../../types/record/label';
import { IModelType } from '../../../types/record/model';
import { BreadcrumbsJp } from '../../breadcrumbs/breadcrumbs';
import { ComponentSwitcher } from '../../shared/component-switcher';
import { MuiTabs } from '../../shared/mui/mui-tabs';
import { Full } from '../../shared/styled/full';
import { Labels } from '../labels/labels';
import { ModelDetail } from '../model-detail/model-detail';
import { ModelImageList } from '../model-image-list/model-image-list';

const vt = viewTexts.pages.modelRoot;

interface Props {
  tabIndex: number;
  tabIndexChange: (idx: number) => void;
  koumutenId: number;
  company: ICompanyType;
  model: IModelType;
  labelList: IList<ILabelFromApiType>;
  imageList: IList<IImageInfoType>;
  onEditLabelClick: () => void;
  onEditModelImagesClick: () => void;
}

export const ModelRootView: FC<Props> = memo(
  ({
    tabIndex,
    tabIndexChange,
    koumutenId,
    company,
    model,
    labelList,
    imageList,
    onEditLabelClick,
    onEditModelImagesClick
  }: Readonly<Props>) => {
    const tabs = useMemo<{ label: string; disabled: boolean }[]>(() => {
      const buttonsEnabled = modelDetailEnabledButtons(model.status);
      return [
        { label: vt.tabs.overview, disabled: false },
        { label: vt.tabs.labelList, disabled: !buttonsEnabled.editLabels },
        {
          label: vt.tabs.modelImageList,
          disabled: !buttonsEnabled.editModelImages
        }
      ];
    }, [model.status]);

    return (
      <Full>
        <BreadcrumbsJp showPadding={true} />
        <MuiTabs
          tabs={tabs}
          index={tabIndex}
          indexChange={tabIndexChange}
          disableRipple={true}
          disableFocusRipple={true}
        />
        <ComponentSwitcher index={tabIndex}>
          <ModelDetail
            model={model}
            labelList={labelList}
            imageList={imageList}
            onEditLabelClick={onEditLabelClick}
            onEditModelImagesClick={onEditModelImagesClick}
          />
          <Labels />
          <ModelImageList
            koumutenId={koumutenId}
            company={company}
            model={model}
          />
        </ComponentSwitcher>
      </Full>
    );
  }
);

ModelRootView.displayName = 'ModelRootView';
